<template>
	<div class="content">
		<LayoutBanner />

		<div class="contact min_cw">
			<div class="top">
				<h2 class="title">联系我们</h2>
			</div>

			<div v-loading="loading" class="con">
				<div class="left">
					<img :src="$http.fileUrl + infoData.contrac_pic" alt="">
				</div>
				<div class="right">
					<h2 class="title">{{ infoData.company_name }}</h2>
					<p class="text">电话： {{ infoData.phone }}</p>
					<p class="text">邮箱： {{ infoData.mail }}</p>
					<p class="text">地址： {{ infoData.address }}</p>
					<p class="text">邮编： {{ infoData.zipcode }}</p>
				</div>
			</div>

			<div class="list_box">
				<h2 class="title">联系方式</h2>
				<ul class="list">
					<li v-for="(item, index) in contactList" :key="index">
						{{ item.company_name }}{{ item.contact_user ? `（${item.contact_user}）` : '' }}：{{ item.phone }}
					</li>
				</ul>
			</div>

			<ContactMap :data="infoData" />
		</div>
	</div>
</template>

<script>
import LayoutBanner from "@/components/Layout/banner";
import ContactMap from './map'
import {getContactUsListApi} from "@/api";

export default {
	name: "index",
	components: {
		LayoutBanner,
		ContactMap,
	},
	data() {
		return {
			loading: false,
			infoData: {},
			contactList: [],
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			this.loading = true;
			await this.getCompanyInfo();
			await this.getContactList();
			this.loading = false;
		},

		/**
		 * 获取企业信息
		 */
		async getCompanyInfo() {
			const res = await getContactUsListApi({ contact_type: 0 });
			this.infoData = res.data[0] ? res.data[0] : {};
		},

		/**
		 * 获取联系人列表
		 */
		async getContactList() {
			const res = await getContactUsListApi({ contact_type: 1 });
			this.contactList = res.data;
		},
	}
}
</script>

<style lang="less" scoped>
.contact {
	padding: 60px 40px;

	.top {
		margin-bottom: 50px;

		.title {
			font-size: 22px;
			color: @blackLine;
			line-height: 1.6;
		}
	}

	.con {
		width: 100%;
		display: flex;
		height: 350px;

		.left {
			flex-shrink: 0;
			width: 50%;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.right {
			flex-shrink: 0;
			width: 50%;
			height: 100%;
			padding: 40px 70px;
			overflow: hidden;

			.title {
				font-size: 24px;
				color: @red;
				font-weight: bold;
				margin-bottom: 25px;
			}

			.text {
				color: @gray;
				margin-bottom: 15px;
				line-height: 1.6;
			}
		}
	}

	.list_box {
		width: 100%;
		margin-top: 40px;

		.title {
			font-size: 22px;
			color: @blackLine;
			margin-bottom: 10px;
		}

		.list {
			display: flex;
			font-size: 14px;
			line-height: 1.6;
			flex-wrap: wrap;

			>li {
				flex-shrink: 0;
				width: 50%;
				padding-right: 20px;
			}
		}
	}
}
</style>
